
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnCheck from "@/components/scope/btn-check.vue";
import { priceRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import { InjectFunction } from "@common/src/utils/decorator";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const setting = namespace("setting");
const common_base = namespace("common_base");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit")
@Component({
  components: { BtnCheck, MyCheckbox }
})
export default class OutWarehouseEdit extends Vue {
  @setting.State serviceMode;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @parts.Action getPartsDetail;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @inventory.Action getOutWarehouseDetail;
  @inventory.Action outWarehouseComplete;
  @inventory.Action queryInventoryAndNotice;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveOutWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @inventory.Action queryWarehouseByInventory;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  @inventory.Action queryPartsCostPrice;
  get breadData() {
    return [
      { name: t("warehouse.outbound-manage"), path: "/inventory/out-warehouse" },
      { name: this.isAdd ? t("v210801.new-out-warehouse-order") : t("v210801.edit-out-warehouse-order") }
    ];
  }
  get isAdd() {
    return this.$route.name === "outWarehouseAdd";
  }
  orderFormDataRules = {
    outboundType: [{ required: true, message: t("v210801.pls-select-outbound-type"), trigger: "change" }]
  };
  handleQtyCheck(row, prop) {
    // let selectedWarehouse = row.warehouseList.find(item => row.warehouseCode === item.code);
    let selectedShelf = row.shelfList.find(item => row.shelfCode === item.code);
    if (selectedShelf) {
      // 如果有选择的仓库，才判断
      if (row.qty > selectedShelf.qty) {
        if (prop === "qty") {
          row.showQtyTips = true;
        } else {
          row.showWarehouseTips = true;
        }
        setTimeout(() => {
          row.showQtyTips = false;
          row.showWarehouseTips = false;
        }, 3000);
      } else {
        row.showQtyTips = false;
        row.showWarehouseTips = false;
      }
    }
  }
  get isStandardModeSaleType() {
    // 销售领料不能选择其他零配件
    return !this.isAdd && this.serviceMode === "1" && this.orderFormData.outboundType === "2";
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any[] = [{}];
  orderFormData: any = {
    outboundType: "3",
    outboundUser: "",
    remark: "",
    detailList: [],
    costAmount: "0"
  };
  get isAutomaticGeneratedOrder() {
    return !!this.orderFormData.orderNo;
  }
  get isEditUnitPrice() {
    return false;
  }
  definitionPartsData: any = {
    partsInfo: {},
    costAmount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    shelfCode: "",
    partsUnit: "",
    remark: "",
    warehouseList: [],
    inboundBatchList: [],
    productionBatchList: [],
    shelfList: [],
    manual: true,
    showQtyTips: false,
    showWarehouseTips: false
  };

  serviceItemList: any[] = [];

  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }

  created() {
    this.setPBPX(52);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  outWarehouseTypeList: any = [];
  async init() {
    this.getDictionaryList("outbound_type").then(data => {
      // 新增，只保留其他出库选项
      this.outWarehouseTypeList = data.filter(item => !this.isAdd || (this.isAdd && item.dataValue === "3"));
    });
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getOutWarehouseDetail({
        outboundNo: this.orderId
      }).then(data => {
        const detailList = data.data.detailList.map(item => {
          return {
            ...this.definitionPartsData,
            ...item,
            manual: false
          };
        });
        this.orderFormData = { ...data.data, detailList };
        this.orderFormData.detailList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push(item);
          }
          this.initWarehouseSelect(item).then(async () => {
            if (this.fifoStatus === "1") {
              await this.initInboundBatchNoSelect(item);
            }
            if (this.productionBatchNoStatus === "1") {
              await this.initProductionBatchNoSelect(item);
            }
            this.initShelfSelect(item);
          });
        });
        if (!this.isStandardModeSaleType) {
          this.getPartsLists("");
        }
      });
    } else {
      this.getPartsLists("");
      this.orderFormData.outboundUser = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  computedAmount(row, index?) {
    if (index !== undefined) {
      let costAmount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
      this.orderFormData.detailList[index].costAmount = costAmount.i18nToFixed();
    } else {
      row.costAmount = ((row.qty || 0) * row.costPrice).i18nToFixed();
    }
    console.log(row.costAmount);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.detailList.reduce((preV, curV) => preV + Number(curV.costAmount), 0);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.costAmount = partsTotal.i18nToFixed();
  }
  searchParts(val) {
    if (this.isStandardModeSaleType) {
      return false;
    }
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let outboundNo = orderId || this.orderId;
    this.outWarehouseComplete({
      outboundNo: outboundNo
    })
      .then(data => {
        this.$message.success(t("warehouse.outbound-success"));
        if (data.data.validateInventoryAlert === "1") {
          const partsCodeList = this.orderFormData.detailList.map(item => item.partsCode);
          if (partsCodeList && partsCodeList.length > 0) {
            this.queryInventoryAndNotice(partsCodeList);
          }
        }
        this.showOutConfirmTips = false;
        this.$router.push(`/inventory/out-warehouse-view/${outboundNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  disableInput(key, row) {
    switch (key) {
      case "warehouseCode": {
        return !row.partsCode;
      }
      case "inboundBatchNo": {
        return !row.warehouseCode;
      }
      case "productionBatchNo": {
        return this.fifoStatus === "1" ? !row.inboundBatchNo : !row.warehouseCode;
      }
      case "shelfCode": {
        if (this.productionBatchNoStatus === "1") {
          return !row.productionBatchNo;
        }
        return this.disableInput("productionBatchNo", row);
      }
      default:
        false;
    }
  }
  async initWarehouseSelect(row, setDefault = false) {
    const data = await this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      dimension: 10
    });
    row.warehouseList = data.data.itemList;
    row.totalInventory = data.data.currentTotalInventory;
    if (setDefault) {
      row.warehouseCode = data.data.defaultCode;
      this.handleWarehouseChange(row);
    }
  }
  async initInboundBatchNoSelect(row) {
    const data = await this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.warehouseCode,
      dimension: 20
    });
    row.inboundBatchList = data.data.itemList;
  }
  async initProductionBatchNoSelect(row) {
    const data = await this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.warehouseCode || undefined,
      inboundBatchNo: row.inboundBatchNo || undefined,
      dimension: 30
    });
    row.productionBatchList = data.data.itemList;
  }
  async initShelfSelect(row, setDefault = false) {
    const data = await this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.warehouseCode || undefined,
      productionBatchNo: row.productionBatchNo || undefined,
      inboundBatchNo: row.inboundBatchNo || undefined,
      dimension: 40
    });
    row.shelfList = data.data.itemList;
    if (setDefault) {
      row.shelfCode = data.data.defaultCode;
      this.getPartsCostPrice(row);
    }
  }
  handleChooseParts(val, row) {
    const partsItem = this.partsList.find(i => i.partsCode === val);
    row.partsUnit = partsItem.partsUnit;

    this.initWarehouseSelect(row, true);
    row.warehouseCode = "";
    row.inboundBatchNo = "";
    row.productionBatchNo = "";
    row.shelfCode = "";
  }
  handleWarehouseChange(row) {
    if (this.fifoStatus === "1") {
      this.initInboundBatchNoSelect(row);
    } else if (this.productionBatchNoStatus === "1") {
      this.initProductionBatchNoSelect(row);
    } else {
      this.initShelfSelect(row, true);
    }
    row.inboundBatchNo = "";
    row.productionBatchNo = "";
    row.shelfCode = "";
  }
  handleInboundBatchNoChange(row) {
    if (this.productionBatchNoStatus === "1") {
      this.initProductionBatchNoSelect(row);
    } else {
      this.initShelfSelect(row, true);
    }
    row.productionBatchNo = "";
    row.shelfCode = "";
  }

  handleProductionBatchNoChange(row) {
    this.initShelfSelect(row, true);
    row.shelfCode = "";
  }

  checkAddData(): boolean {
    if (!this.orderFormData.outboundType) {
      this.$message.error(t("v210801.pls-select-outbound-type"));
      return false;
    }
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210831.please-select-stock-output-parts"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210831.please-fill-in-output-parts-munber"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }

      if (!element.warehouseCode || !element.shelfCode) {
        this.$message.error(t("v213.please-select-the-outbound-warehouse/location"));
        return false;
      }
      if (this.operationName === "complete") {
        const selectedWarehouse = element.warehouseList.find(item => item.code === element.warehouseCode);
        const selectedShelf = element.shelfList.find(item => item.code === element.shelfCode);
        console.log(selectedShelf);
        if (Number(element.qty) > selectedShelf.qty) {
          this.$message.error(
            `${selectedWarehouse.warehouseName}${t("warehouse.warehouse")}/${selectedShelf.shelfDesc}${t(
              "v213.insufficient-inventory-at-location-please-confirm"
            )}`
          );
          return false;
        }
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSaveOutWarehouse();
  }
  handleSaveOutWarehouse() {
    this.operationName = "save";
    this.emitSaveOutWarehouse();
  }
  emitSaveOutWarehouse() {
    (this.$refs["outWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        // 添加税率的两个字段
        const newOrderFormData = {
          ...this.orderFormData,
          detailList: this.orderFormData.detailList.map(o => {
            return {
              ...o,
              taxIncluded: o.inboundBatchList.find(_ => _.code === o.inboundBatchNo)?.taxIncluded,
              taxRate: o.inboundBatchList.find(_ => _.code === o.inboundBatchNo)?.taxRate
            };
          })
        };
        this.btnStartLoading();
        this.saveOutWarehouse(newOrderFormData)
          .then(data => {
            if (this.operationName === "save") {
              this.$message.success(t("base.save-success") as string);
              this.$router.push(`/inventory/out-warehouse-view/${data.data.outboundNo}`);
            } else {
              this.emitComplete(data.data.outboundNo);
            }
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleAddParts() {
    this.orderFormData.detailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }
  handleShelfSelectFocus(row) {
    if (!row.warehouseCode) {
      this.$message.error(t("v213.please-select-spare-parts-and-outbound-warehouse-first"));
    }
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  handleShelfChange(row) {
    this.handleQtyCheck(row, "shelf");
    this.getPartsCostPrice(row);
  }
  getPartsCostPrice(row) {
    this.queryPartsCostPrice({
      inboundBatchNo: row.inboundBatchNo || undefined,
      partsCode: row.partsCode || undefined,
      productionBatchNo: row.productionBatchNo || undefined,
      shelfCode: row.shelfCode || undefined,
      warehouseCode: row.warehouseCode || undefined
    }).then(({ data }) => {
      row.costPrice = data.costPrice;
      this.computedAmount(row);
    });
  }
  // 2.10
  showOutConfirmTips: boolean = false;
  handleShowOutConfrimTips() {
    this.operationName = "complete";
    (this.$refs["outWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.showOutConfirmTips = true;
      }
    });
  }
}
